import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';

const LabelInfo = ({label, icon, bold = true, className, ...rest}) => (
  <span className={classnames(styles.label, {[styles.bold]: bold}, className)} {...rest}>
    {icon && <img src={icon} alt="info" className={styles.icon}/>}
    {label}
  </span>
);

LabelInfo.propTypes = {
  label: PropTypes.node,
  bold: PropTypes.bool,
};

export default LabelInfo;
